import { useContext } from "react";
import { motion } from "framer-motion";
import { CubeIcon } from "@heroicons/react/solid";

import { BASIC_ANIMATION_VARIANTS, NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";

import { DashboardContext } from "../../../../context/DashboardContext";
import DashboardContainer from "../../../SharedComponents/DashboardContainer";
import AccessControl from "../../../SharedComponents/AccessControl";
import App from "./App";
import Alert, { ALERT_TYPE } from "../../../../components/Auth/Alert";
import BouncingBalls from "../../../SharedComponents/Loading/BouncingBalls";

function Apps() {
    const context = useContext(DashboardContext);

    return (
        <AccessControl requiredPermission={PERMISSIONS.ACCESS_APPLICATIONS} noAccessType={NO_ACCESS_TYPES.REDIRECT}>
            <DashboardContainer title={"Apps"} titleIcon={<CubeIcon className="block h-5 w-5 mr-2" />}>
                <div className="mb-6">
                    <Alert
                        text={
                            "Please allow pop-ups on your browser (if prompted) by clicking 'Allow' to open Apps. " +
                            "If you are having issues please check browser pop-up permissions for this website."
                        }
                        type={ALERT_TYPE.NEUTRAL}
                        active={true}
                        marginLess
                    />
                </div>
                {context.applicationsLoading ? (
                    <div className={"col-span-full flex items-center justify-center pt-20 pb-24 w-full"}>
                        <BouncingBalls />
                    </div>
                ) : context.userApplications && context.userApplications.length > 0 ? (
                    <motion.div
                        initial={"inactive"}
                        animate={"active"}
                        exit={"inactive"}
                        transition={{ duration: 0.4 }}
                        variants={BASIC_ANIMATION_VARIANTS}
                    >
                        <div className="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 w-full grid-rows-2">
                            {context.userApplications.map((app, i) => (
                                <App
                                    key={i}
                                    name={app.name}
                                    description={app.description}
                                    activated={true}
                                    colour={app.themeColour}
                                    logoUrl={app.logoUrl}
                                    launchUrl={app.launchUrl}
                                    isStatic={app.isStatic}
                                />
                            ))}
                        </div>
                    </motion.div>
                ) : (
                    <motion.div
                        initial={"inactive"}
                        animate={"active"}
                        exit={"inactive"}
                        transition={{ duration: 0.4 }}
                        variants={BASIC_ANIMATION_VARIANTS}
                    >
                        <div>
                            No registered apps! Contact us at{" "}
                            <a
                                className="text-right underline font-medium text-primary-600"
                                href="mailto:techsupport@psychpress.com.au?subject=What application can I use?"
                            >
                                techsupport@psychpress.com.au
                            </a>{" "}
                            or call us at{" "}
                            <a className="link text-primary-600 hover:text-primary-700" href="tel:+61396700590">
                                +61 (0)3 9670 0590
                            </a>{" "}
                            to see how our apps can help you.
                        </div>
                    </motion.div>
                )}
            </DashboardContainer>
        </AccessControl>
    );
}

export default Apps;
